module.exports = __webpack_public_path__ + "static/media/37550017-zeUzwSgs.52760d9f.JPG";